import Api from "shared/service/api/api";

// actions
export const LOAD_SETTINGS = "loadSettings";

// mutations
export const SET_PROJECT_SETTINGS = "setProjectSettings";
export const SET_PROJECT_LINKS = "setProjectLinks";
export const SET_USER_NOTIFY_SETTINGS = "setUserNotifySettings";
export const SET_INVITED_USERS = "setInvitedUsers";

const state = {
  project: {
    id: null,
    name: "",
    logo: [],
    email_sender: "",
    description: "",
    is_last_transition: false,
  },
  user_notify_settings: {
    id: null,
    email_create_order: false,
    email_pay_order: false,
    tg_create_order: false,
    tg_pay_order: false,
    tg_course_events: false,
  },
  invited_users: [],
  links: {
    facebook: "",
    instagram: "",
    linkedin: "",
    odnoklassniki: "",
    personal_website: "",
    twitter: "",
    vkontakte: "",
    youtube: "",
  },
};

const getters = {
  project: (state) => state.project,
  projectName: (state) => state.project.name,
  projectLogo: (state) => state.project.logo,
  projectEmailSender: (state) => state.project.email_sender,
  projectDescription: (state) => state.project.description,
  projectIsLastTransition: (state) => state.project.is_last_transition,
  projectLinks: (state) => state.links,
  projectStateId: (state) => state.project.state_id,

  userNotifySettings: (state) => state.user_notify_settings,
  userNotifySettingsId: (state) => state.user_notify_settings.id,

  emailAfterOrderCreate: (state) => state.user_notify_settings.email_create_order,
  emailAfterOrderPay: (state) => state.user_notify_settings.email_pay_order,

  telegramAfterOrderCreate: (state) => state.user_notify_settings.tg_create_order,
  telegramAfterOrderPay: (state) => state.user_notify_settings.tg_pay_order,
  telegramCourseEvents: (state) => state.user_notify_settings.tg_course_events,

  invitedUsers: (state) => state.invited_users,

  projectAccessLevels: () => [
    {
      id: 1,
      name: "Владелец проекта",
      description: null,
    },
    {
      id: 2,
      name: "Совладелец проекта",
      description: "Имеет полные права, как у владельца. Но выводить деньги может только владелец проекта",
    },
    {
      id: 3,
      name: "Менеджер проекта",
      description: "Не имеет доступа к статистике",
    },
    {
      id: 4,
      name: "Модератор курсов",
      description: "Доступ только к разделу «Курсы»",
    },
  ],
};

const actions = {
  [LOAD_SETTINGS]({ commit }) {
    return new Promise((resolve, reject) => {
      Api.project.settings
        .get()
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          commit(SET_PROJECT_SETTINGS, response.data.project);
          commit(SET_PROJECT_LINKS, response.data.links);
          commit(SET_USER_NOTIFY_SETTINGS, response.data.user_notify_settings);
          commit(SET_INVITED_USERS, response.data.invited_users);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
};

const mutations = {
  [SET_PROJECT_SETTINGS](state, data) {
    state.project = data;
  },
  [SET_PROJECT_LINKS](state, links) {
    state.links = links;
  },
  [SET_USER_NOTIFY_SETTINGS](state, data) {
    state.user_notify_settings = data;
  },
  [SET_INVITED_USERS](state, data) {
    state.invited_users = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
